// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3bTEc","title":"Header_title__KK9dO","left":"Header_left__T5suI","clinicName":"Header_clinicName__-9HTQ"};